export default {
  API_URL: 'https://api.arivilloso.com',
  IMAGE_API_URL: ' https://thumb.arivilloso.com',
  FILE_API_URL: ' https://files.arivilloso.com'
};
